// 课程相关API接口
import apiClient, { API_ENDPOINTS } from "@/config/api";

/**
 * 课程API类
 */
export class CourseAPI {
  /**
   * 获取课程列表
   */
  static async getCourseList() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.COURSE.LIST);
      
      // 检查响应格式，确保返回正确的结构
      if (Array.isArray(response)) {
        // 如果拦截器返回的是数组，包装成标准格式
        return {
          success: true,
          data: response,
          message: "获取课程列表成功"
        };
      } else if (response && response.success !== undefined) {
        // 如果已经是标准格式，直接返回
        return response;
      } else {
        // 其他情况，包装成标准格式
        return {
          success: true,
          data: response,
          message: "获取课程列表成功"
        };
      }
    } catch (error) {
      console.error("获取课程列表失败:", error);
      return {
        success: false,
        data: null,
        message: error.message || "获取课程列表失败"
      };
    }
  }

  /**
   * 获取购买的课程列表
   */
  static async getMyCourseList(){
    try {
      const response = await apiClient.get(API_ENDPOINTS.COURSE.MYLIST);
      
      // 检查响应格式，确保返回正确的结构
      if (Array.isArray(response)) {
        // 如果拦截器返回的是数组，包装成标准格式
        return {
          success: true,
          data: response,
          message: "获取课程列表成功"
        };
      } else if (response && response.success !== undefined) {
        // 如果已经是标准格式，直接返回
        return response;
      } else {
        // 其他情况，包装成标准格式
        return {
          success: true,
          data: response,
          message: "获取课程列表成功"
        };
      }
    } catch (error) {
      console.error("获取课程列表失败:", error);
      return {
        success: false,
        data: null,
        message: error.message || "获取课程列表失败"
      };
    }
  }

  /**
   * 获取课程详情
   */
  static async getCourseDetail(courseId) {
    try {
      const response = await apiClient.get(API_ENDPOINTS.COURSE.DETAIL, {
        params: { courseId }
      });
      
      return {
        success: true,
        data: response.data || response,
        message: "获取课程详情成功"
      };
    } catch (error) {
      console.error("获取课程详情失败:", error);
      return {
        success: false,
        data: null,
        message: error.message || "获取课程详情失败"
      };
    }
  }

  /**
   * 开始学习课程
   */
  static async startCourse(courseId) {
    try {
      const response = await apiClient.post(API_ENDPOINTS.COURSE.START, {
        courseId
      });
      
      return {
        success: true,
        data: response.data || response,
        message: "开始学习课程成功"
      };
    } catch (error) {
      console.error("开始学习课程失败:", error);
      return {
        success: false,
        data: null,
        message: error.message || "开始学习课程失败"
      };
    }
  }

  /**
   * 更新课程进度
   */
  static async updateProgress(courseId, progress, masteredWords = 0, studyTime = 0) {
    try {
      const response = await apiClient.post(API_ENDPOINTS.COURSE.PROGRESS, {
        courseId,
        progress,
        masteredWords,
        studyTime
      });
      
      return {
        success: true,
        data: response.data || response,
        message: "更新课程进度成功"
      };
    } catch (error) {
      console.error("更新课程进度失败:", error);
      return {
        success: false,
        data: null,
        message: error.message || "更新课程进度失败"
      };
    }
  }

  /**
   * 获取课程下的单元列表
   */
  static async getUnits(stageId) {
    try {
      const response = await apiClient.post(API_ENDPOINTS.COURSE.UNITS, {
        stageId
      });
      
      return {
        success: true,
        data: response.data || response,
        message: "获取单元列表成功"
      };
    } catch (error) {
      console.error("获取单元列表失败:", error);
      return {
        success: false,
        data: null,
        message: error.message || "获取单元列表失败"
      };
    }
  }

  /**
   * 获取单元单词列表（分页）
   */
  static async getUnitWords(unitId, page = 1, pageSize = 10) {
    try {
      const response = await apiClient.post(API_ENDPOINTS.COURSE.UNIT_WORDS, {
        unitId,
        page,
        pageSize
      });
      
      return {
        success: true,
        data: response.data || response,
        message: "获取单元单词成功"
      };
    } catch (error) {
      console.error("获取单元单词失败:", error);
      return {
        success: false,
        data: null,
        message: error.message || "获取单元单词失败"
      };
    }
  }

  /**
   * 提交单元学习结果
   */
  static async submitUnitLearning(unitId, words, studyTime, studyDate) {
    try {
      const response = await apiClient.post(API_ENDPOINTS.COURSE.SUBMIT_UNIT_LEARNING, {
        unitId,
        words,
        studyTime,
        studyDate
      });
      
      return {
        success: true,
        data: response.data || response,
        message: "提交学习结果成功"
      };
    } catch (error) {
      console.error("提交学习结果失败:", error);
      return {
        success: false,
        data: null,
        message: error.message || "提交学习结果失败"
      };
    }
  }
}

export default CourseAPI;
